"use client";

import React, { useState, useEffect, useRef } from "react";
import { PrismicLink, SliceZone } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import { isFilled } from "@prismicio/client";
import { components } from "@/slices";

export default function CHeader({ slices, name, context, icons }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const fallbackAlt = "Image de contenu";
  const menuPanelRef = useRef(null);
  const menuToggleButtonRef = useRef(null);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'unset';
    }

    return () => {
      document.body.style.overflowY = 'unset';
    };
  }, [menuOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!menuOpen) return;

    const handleOutsideClick = (event) => {
      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      if (!isDesktop) return;

      if (menuToggleButtonRef.current && menuToggleButtonRef.current.contains(event.target)) {
        return;
      }

      if (menuPanelRef.current && !menuPanelRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [menuOpen]);


  return (
    <header
      className={`w-full z-120 fixed top-0 flex flex-col items-end`}
    >
      <div className={`px-4 md:px-10 flex items-center relative justify-between w-full py-2.5 md:py-3 ${isScrolled ? "bg-white" : "bg-transparent"} ${menuOpen ? "bg-white" : "bg-inherit"} transition-colors duration-300`}>
        <a href="/" className="min-h-[52px] flex flex-col justify-center">
          <div className="font-medium text-sm uppercase font-neue-haas">MÉLISSA WAUCQUIER Ⓓ</div>
          {isFilled.keyText(name) && <div className="font-extralight font-neue-haas text-2xl uppercase">[ {name} ]</div>}
        </a>
        {/* Burger Menu */}
        <div className={`flex lg:flex-row-reverse gap-6  ${menuOpen ? 'items-center' : 'items-end'}`}>

          {isFilled.group(icons) && (
            <>
              {
                icons.map((item, index) => (
                  <PrismicLink
                    key={index}
                    field={item.cta}
                    className="w-full cursor-pointer"
                  >
                    <PrismicNextImage
                      field={item.img}
                      alt={item.img?.alt || fallbackAlt}
                      className="h-10 w-auto"
                    />
                  </PrismicLink>
                ))
              }
            </>
          )}

          <button
            ref={menuToggleButtonRef}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
            className="cursor-pointer h-[34px]"
          >
            {menuOpen ? (
              <svg width="22" height="34" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.8574 21.1504L21.1503 21.8575L-7.55191e-05 0.707107L0.707031 0L21.8574 21.1504Z" fill="black" />
                <path d="M21.1504 0.214397L21.8575 0.921504L0.707107 22.0719L0 21.3648L21.1504 0.214397Z" fill="black" />
              </svg>
            ) : (
              <svg width="21" height="34" viewBox="0 0 21 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 0V1H0V0H21Z" fill="black" />
                <path d="M21 16.5V17.5H0V16.5H21Z" fill="black" />
                <path d="M21 32.5V33.5H0V32.5H21Z" fill="black" />
              </svg>
            )}
          </button>
        </div>
      </div>
      {menuOpen &&
        <div
          ref={menuPanelRef}
          className={`h-[calc(100vh-72px)] md:h-[calc(100vh-112px)] bg-white w-full lg:w-[40%] overflow-scroll no-scrollbar transition-all duration-300 ${menuOpen ? 'translate-x-0 animate-slide-in' : 'translate-x-full pointer-events-none'
            }`}
        >
          <div className="flex flex-col gap-5 justify-center items-end p-10 md:px-30 min-h-full">
            <SliceZone slices={slices} components={components} context={{ ...context }} />
          </div>
        </div>
      }
    </header>
  );
}
